import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { getFormValues, isValid, reset } from 'redux-form';

import * as adminLib from 'libs/adminLib';

import { Image, Button, Label } from 'semantic-ui-react';

import { ReduxFormMaterialTextField } from 'components';

import classNames from 'classnames/bind';
import styles from './CtAdminLogin.css';
const cx = classNames.bind(styles);

class CtAdminChangePW extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorMessage: {
        type: '',
        content: ''
      }
    };
  }

  // 로그인
  onLogin = () => {
    return window.location.replace('/mudmanage');
  };

  // 관리자 계정 최초 수정
  onChangePasswd = async () => {
    if (!this.state.isLoading) {
      this.setState({ isLoading: true });

      try {
        // 국제화 처리
        const { formatMessage } = this.props.intl;
        const { formAdminChangePasswd, isValidFormAdminChangePasswd } = this.props;

        if (isValidFormAdminChangePasswd) {
          this.setState({ isClicked: true });

          if (formAdminChangePasswd.userPasswd === formAdminChangePasswd.userPasswdCheck) {
            const params = {
              beforePasswd: formAdminChangePasswd.beforePassword,
              newPasswd: formAdminChangePasswd.userPasswd
            };

            const respObj = await adminLib.editPassword(params);
            if (respObj && respObj.status && respObj.status === 200) {
              if (respObj.data && Array.isArray(respObj.data.list)) {
                // ID/Password 변경 성공
                this.setState({
                  errorMessage: {
                    type: 'success',
                    content: (
                      <div className={cx('success-area brand bold font-size-16')}>
                        {defineMessages(formatMessage({ id: 'CtAdminChangePW_1', defaultMessage: '변경 완료!' }))}
                      </div>
                    )
                  }
                });
              } else {
                if (Array.isArray(respObj.data.error)) {
                  this.setState({
                    errorMessage: {
                      type: 'beforePassword',
                      content: respObj.data.error[0].errInfo
                    }
                  });
                } else {
                  // 비밀번호 틀림
                  this.setState({
                    errorMessage: {
                      type: 'beforePassword',
                      content: defineMessages(
                        formatMessage({ id: 'CtAdminChangePW_2', defaultMessage: '비밀번호가 틀렸습니다.' })
                      )
                    }
                  });
                }
              }
            } else {
              // 응답 오류
            }
          } else {
            // 비밀번호와 비밀번호 체크 일치 안함
            this.setState({
              errorMessage: {
                type: 'userPasswdCheck',
                content: defineMessages(
                  formatMessage({ id: 'CtAdminChangePW_3', defaultMessage: '비밀번호가 일치하지 않습니다.' })
                )
              }
            });
          }
        }
      } catch (e) {
        console.log(e);
      }

      this.setState({ isLoading: false });
    }
  };

  handleKeyPress = e => {
    if (e.key.toLowerCase() === 'enter') {
      this.onChangePasswd();
    }
  };

  render() {
    const { formatMessage } = this.props.intl;

    return (
      <div className={cx('admin-first-edit-area change-passwd')}>
        <div className={cx('display-flex')}>
          <Image src="/img/logo/m_logo.png" />
          <div>
            <Label className={cx('admin-title')}>
              {defineMessages(formatMessage({ id: 'CtAdminChangePW_4', defaultMessage: '비밀번호 기간 만료' }))}
            </Label>
            <div className={cx('bold mt-5')}>
              {defineMessages(formatMessage({ id: 'CtAdminChangePW_5', defaultMessage: '비밀번호를 변경 해주세요.' }))}
            </div>
          </div>
        </div>
        {this.state.errorMessage.type === 'success' ? (
          this.state.errorMessage.content
        ) : (
          <div>
            <div className={cx('wrap-input')}>
              <span className="materialTextField-title">
                {defineMessages(formatMessage({ id: 'CtAdminChangePW_6', defaultMessage: '기존 비밀번호' }))}
              </span>

              <ReduxFormMaterialTextField
                className={cx('input-area')}
                type="password"
                fullWidth
                validate={['required', 'gsPassword']}
                name="beforePassword"
                checkType={101}
                onKeyPress={this.handleKeyPress}
                error={this.state.errorMessage.type === 'beforePassword' ? true : false}
                errorText={this.state.errorMessage.type === 'beforePassword' && this.state.errorMessage.content}
              />
              <span className="materialTextField-title">
                {defineMessages(formatMessage({ id: 'CtAdminChangePW_7', defaultMessage: '새 비밀번호' }))}
              </span>
              <ReduxFormMaterialTextField
                className={cx('input-area')}
                type="password"
                fullWidth
                validate={['required', 'gsPassword']}
                name="userPasswd"
                checkType={101}
                onKeyPress={this.handleKeyPress}
                error={this.state.errorMessage.type === 'userPasswd' ? true : false}
                errorText={this.state.errorMessage.type === 'userPasswd' && this.state.errorMessage.content}
              />
              <span className="materialTextField-title">
                {defineMessages(formatMessage({ id: 'CtAdminChangePW_8', defaultMessage: '새 비밀번호 확인' }))}
              </span>
              <ReduxFormMaterialTextField
                className={cx('input-area')}
                type="password"
                fullWidth
                validate={['required', 'gsPassword']}
                name="userPasswdCheck"
                checkType={101}
                onKeyPress={this.handleKeyPress}
                error={this.state.errorMessage.type === 'userPasswdCheck' ? true : false}
                errorText={this.state.errorMessage.type === 'userPasswdCheck' && this.state.errorMessage.content}
              />
            </div>
          </div>
        )}
        <div>
          {this.state.errorMessage.type === 'success' ? (
            <div className={cx('button-area')}>
              <Button className={cx('bt-change')} onClick={this.onLogin}>
                {defineMessages(formatMessage({ id: 'CtAdminChangePW_9', defaultMessage: '로그인' }))}
              </Button>
            </div>
          ) : (
            <div className={cx('button-area')}>
              <Button className={cx('bt-change')} onClick={this.onChangePasswd}>
                {defineMessages(formatMessage({ id: 'CtAdminChangePW_10', defaultMessage: '변경' }))}
              </Button>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  formAdminChangePasswd: getFormValues('formAdminChangePasswd')(state),
  isValidFormAdminChangePasswd: isValid('formAdminChangePasswd')(state)
});

export default connect(mapStateToProps)(
  reduxForm({
    form: 'formAdminChangePasswd',
    enableReinitialize: true,
    destroyOnUnmount: false,
    touchOnChange: true // validation 안내를 적절한 시점에 보이기 위해 반드시 필요함
  })(injectIntl(CtAdminChangePW))
);



// WEBPACK FOOTER //
// ./src/script/containers/admin/CtAdminChangePW.js